import { createSelector } from 'reselect';
import _ from 'lodash';
import {
  offerSelector,
  aggregateOffers,
  LobValuesfromAggregate,
  formatOffersForDataLayer
} from './offersHelpers';
import {
  offerLOBselector,
  offerPriceSelector
} from './filterSelectors';

export const currentSortSelector = state => state.offers.currentSort;
export const sortTitleSelector = state => state.offers.sortTitle;
export const sortItemsSelector = state => state.offers.sortItems;

export const availableSortItemsSelector = createSelector(
  sortItemsSelector,
  offerLOBselector,
  (sortItems, lobs) => {
    const items = _.map(sortItems, (item) => {
      return {
        ...item,
        options: _.filter(item.options, (item) => _.find(lobs, item.key))
      };
    });

    return _.filter(items, (item) => item.options.length > 0);
  }
);

export const sortSelector = createSelector(
  availableSortItemsSelector,
  currentSortSelector,
  (sortItems, currentSort) => {
    const selection =  !_.isEmpty(sortItems) && !_.isEmpty(currentSort) &&
    _.find(_.flatMap(sortItems, 'options'), {key: currentSort[0], dir: currentSort[1]});

    return selection || {key: '', dir: ''};
  }
);

//Sort offers by the current selected sort criteria
export const offerSortSelector = createSelector(
  offerPriceSelector,
  sortSelector,
  (offers, sort) => {
    const sortedOffers = _.orderBy(offers, sort.key, sort.dir.toLowerCase()),
          sortKey = sort.key.split('.');

    // all further logic places null values last in all cases.
    let lastNullIndex = -1;

    _.forEach(sortedOffers, (sortedOffer, index) => {
      let isNullVal = false,
          tempObj = sortedOffer;

      _.forEach(sortKey, key => {
        if (tempObj.hasOwnProperty(key) && !_.isNull(tempObj[key])) {
          tempObj = tempObj[key];
        } else {
          isNullVal = true;
        }
      });
      if (isNullVal) {
        lastNullIndex = index;
      }
    });

    lastNullIndex = lastNullIndex + 1;

    return [
      ...sortedOffers.slice(lastNullIndex),
      ...sortedOffers.slice(0, lastNullIndex)
    ];
  }
);

export const offerServerFilteredSelector = createSelector(
  offerSelector,
  (processedOffers) => aggregateOffers(processedOffers)
);

export const offerClientFilteredSelector = createSelector(
  offerSortSelector,
  (processedOffers) => aggregateOffers(processedOffers)
);

export const offerClientUnfilteredSelector = createSelector(
  offerSortSelector,
  unprocessedOffers => unprocessedOffers
);

export const currentLobValuesServer = createSelector(
  offerServerFilteredSelector,
  (offers) => LobValuesfromAggregate(offers)
);

//LOBs for the sticky header need to be calculated last,
//because it needs to be accurate for both user selection and default offers
export const currentLobValues = createSelector(
  offerClientFilteredSelector,
  offers => LobValuesfromAggregate(offers)
);

export const dlDisplayedOffersSelector = createSelector(
  offerSortSelector,
  offers => formatOffersForDataLayer(offers)
);



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/offers/sortSelectors.js
 **/